import { render, staticRenderFns } from "./QuizBlock.vue?vue&type=template&id=2d7a212f&"
import script from "./QuizBlock.vue?vue&type=script&lang=js&"
export * from "./QuizBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports